import axios from 'axios';
import _ from 'lodash';

export const listUserGroupProvider = async ({ page, limit }) => {
  const res = await axios.get(`/cms/user_group/provider/list`, {
    params: { page: page, limit: limit },
  });
  if (res.data.code === 0) {
    return _.get(res, 'data.data', {});
  }
};

export const listUserGroupPlatform = async (provider_code, data) => {
  const res = await axios.get(`/cms/user_group/provider/${provider_code}/list`, {
    params: { ...data },
    paramsSerializer: (params) => {
      // Filter out empty/undefined values
      const filtered = Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== undefined && value !== ''),
      );

      // Convert to query string
      return new URLSearchParams(filtered).toString();
    },
  });
  if (res.data.code === 0) {
    return _.get(res, 'data.data', {});
  }
};

export const createUserGroup = (payload) => {
  return axios
    .post(`/cms/user_group`, payload)
    .then((res) => {
      return _.get(res, 'data', {});
    })
    .catch((error) => {
      return _.get(error, 'response', {});
    });
};

export const createOrUpdateUserGroup = (payload) => {
  return axios
    .post(`/cms/user_group/create_or_update`, payload)
    .then((res) => {
      return _.get(res, 'data', {});
    })
    .catch((error) => {
      return _.get(error, 'response', {});
    });
};

export const removeUserGroupById = (id) => {
  return axios
    .delete(`/cms/user_group/${id}`)
    .then((res) => {
      return _.get(res, 'data', {});
    })
    .catch((error) => {
      return _.get(error, 'response', {});
    });
};

export const removeUserGroupByCode = (code) => {
  return axios
    .delete(`/cms/user_group/code/${code}`)
    .then((res) => {
      return _.get(res, 'data', {});
    })
    .catch((error) => {
      return _.get(error, 'response', {});
    });
};
